<div class="card">
  <app-header
    titulo="Comandos"
    descricao="Gerenciamento de todos os comandos (SQL ou API) dos recursos de integração.">
  </app-header>

  <p-table
    [value]="comandos"
    [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped"
    [paginator]="true"
    [rows]="20"
    [globalFilterFields]="['nome', 'descricao', 'recursoNome', 'tipo']">

    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center">
        <p-button
          label="Atualizar"
          icon="pi pi-refresh"
          (onClick)="carregarComandos()"
          [loading]="loading">
        </p-button>
        <!-- Filtro por recurso -->
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="tipo">Tipo <p-sortIcon field="tipo"></p-sortIcon></th>
        <th pSortableColumn="recursoNome">Recurso Associado <p-sortIcon field="recursoNome"></p-sortIcon></th>
        <th pSortableColumn="ativo">Status <p-sortIcon field="ativo"></p-sortIcon></th>
        <th style="width: 8rem">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-comando>
      <tr>
        <td><strong>{{ comando.nome }}</strong></td>
        <td>
          <p-tag [severity]="comando.tipo === 'DATABASE_SQL' ? 'info' : 'success'">
            <i [class]="getTipoComandoIcon(comando.tipo) + ' mr-2'"></i>
            {{ comando.tipo === 'DATABASE_SQL' ? 'Database SQL' : 'API Endpoint' }}
          </p-tag>
        </td>
        <td>{{ comando.recursoNome }}</td>
        <td>
          <p-tag [value]="comando.ativo ? 'Ativo' : 'Inativo'" [severity]="comando.ativo ? 'success' : 'danger'"></p-tag>
        </td>
        <td>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deletarComando(comando)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center p-4">Nenhum comando encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
